import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import { Link, useNavigate } from 'react-router-dom';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import pptxgen from 'pptxgenjs';
import globalIP from '../../GlobelIP';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  Modal,
  IconButton,
  Table,
  CellProps,
  Dropdown,
  Input,
  SelectPicker,
  FlexboxGrid,
  Col,
  Message,
  useToaster,
  Tooltip,
  Whisper,
  InputNumber
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import ProjectIcon from '@rsuite/icons/Project';
import { useLocation } from 'react-router-dom';
import TreemapIcon from '@rsuite/icons/Treemap';
import ugr from '@/UGRoute';
import axios from 'axios';
import AddRemoveProductModal from '@/components/AddRemoveProductModal';
import ShowDimensionModal from '@/components/ShowDimensionModal';
import TableCustomizeDetails from '@/components/TableEditDetails/TableCustomizeDetails';

type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    SellingPrice: number;
    MOQ: number;
    // Add other attribute properties here
  };
};

const { Cell } = Table;

export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData[dataKey!]} width="40" />
    </div>
  </Cell>
);

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}
let catalogueCodeCounter = 1;


const EditDetailsQ = () => {

  const ipp = globalIP;

  const { HeaderCell, Cell } = Table;

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [sizeshow, setSizeShow] = useState(false);
  const [finShow, setFinShow] = useState(false);

  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      setFinShow(json.data[0].attributes.setFinish);

      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [showDimm, setShowDimm] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenDimm = (row) => {
    setSelectedRow(row);
    console.log('ROW :', row)
    setShowDimm(true);
  }
  const handleCloseDimm = () => setShowDimm(false);

  const defaultColumns = [
    {
      key: 'serialNumber',
      label: <b>Sr.No.</b>,
      fixed: true,
      width: 60
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell className="image-cell">
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="img-hover">
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 400, objectFit: 'contain' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.Description" />
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductName" />
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Length, Width, Height, SizeUnit, SetStatus, SetSizes } = rowData.attributes;
            if (SetStatus === 'Set' && Array.isArray(SetSizes)) {
              return <Button active onClick={() => handleOpenDimm(rowData.attributes.SetSizes)}>View Size</Button>
            }
            else {
              return `${Length} x ${Width} x ${Height} ${SizeUnit}`
            }
          }}
        </Cell>
      )
    },
    {
      key: 'SellingPrice',
      label: `${label[0]?.attributes.SalePrice}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.SalePrice}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell dataKey="attributes.SalePrice">
          {rowData => (
            <InputNumber
              value={rowData.attributes.SellingPrice} // Display existing value
              onChange={newValue => handlePriceChange(newValue, rowData.attributes.ProductId)}
              style={{ width: '80px' }}
            />
          )}
        </Table.Cell>
      )
    },
    {
      key: 'MOQ',
      label: `${label[0]?.attributes.MOQ}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.MOQ}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell dataKey="attributes.MOQ">
          {rowData => (
            <InputNumber
              value={rowData.attributes.MOQ}
              onChange={newValue => handleMoqChange(newValue, rowData.attributes.ProductId)}
              style={{ width: '80px' }} // Adjust the width as needed
            />
          )}
        </Table.Cell>
      )
    },
    {
      key: 'cbm',
      label: `${label[0]?.attributes.cbm}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.cbm}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.cbm" />
    },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.FinishName" />
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ColorName" />
    },

    {
      key: 'Action',
      label: 'Action',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {rowData => dataWithSerialNumbers.length > 1 && (
            <IconButton
              size="sm"
              icon={<TrashIcon />}
              active
              onClick={() => handleDeleteRow(rowData.id)}
            />
          )}
        </Table.Cell>
      )
    }
  ];

  const handlePriceChange = (newValue, productId) => {
    // Find the product in your state
    const updatedProducts = data1234.map(item => {
      if (item.attributes.ProductId === productId) {
        console.log(`updating ${item.id}`);
        return {
          ...item,
          attributes: {
            ...item.attributes,
            SellingPrice: newValue
          }
        };
      }
      return item;
    });
    setData1234(updatedProducts);
  };
  const handleMoqChange = (newValue, productId) => {
    // Find the product in your state
    const updatedProducts = data1234.map(item => {
      if (item.attributes.ProductId === productId) {
        return {
          ...item,
          attributes: {
            ...item.attributes,
            MOQ: newValue
          }
        };
      }
      return item;
    });
    setData1234(updatedProducts);
  };

  const handlePriceandMOQ2 = (price, moq, productId) => {
    // const pid = productId// Ensure pid is a string
    const pid = Number(productId);  // Ensure pid is a string
    const updatedProducts = data1234.map(item => {
      // Compare as strings
      if (item.id === pid) {
        console.log(`updating ${productId} with ${moq} and ${price}`);

        return {
          ...item,
          attributes: {
            ...item.attributes,
            SellingPrice: price,
            MOQ: moq
          }
        };
      }
      return item;
    });
    console.log('updatedProducts');
    console.log(updatedProducts);
    setData1234(updatedProducts);
  };


  const toaster = useToaster();

  const [open3, setOpen3] = React.useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => {
    setOpen3(false);
  };
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
  };
  const [open4, setOpen4] = React.useState(false);
  const handleOpen4 = () => setOpen4(true);
  const handleClose4 = () => setOpen4(false);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const ip = ipp;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');
  const [loading, setLoading] = useState(true);
  const [compact, setCompact] = React.useState(true);
  const [noData, setNoData] = React.useState(false);
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns.map(column => column.key).filter(key => key !== 'ProductCost')
  );
  const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);

  // Fetch Data from API Start
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [meta123, setMeta123] = useState<MetaData>();
  const [data123, setData123] = useState<YourDataType[]>([]);
  const [data1234, setData1234] = useState<YourDataType[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if ((updateQuotation != '') && (updateQuotation != null)) {
      fetchAndProcessQuotationData();
    }
  }, [isDataFetched]);
  useEffect(() => {
    fetchData();

  }, []);
  useEffect(() => {
    console.log('data1234');
    console.log(data1234);


  }, [data1234]);
  const [updateQuotationid, setUpdateQuotationid] = useState('')
  const fetchAndProcessQuotationData = async () => {
    try {
      const response = await fetch(`${ipp}/api/quotations?populate=*&filters[QuotationCode][$eq]=${updateQuotation}`);
      const json = await response.json();
      setUpdateQuotationid(json.data[0].id)
      setQut(json.data[0].attributes)
      let updatedProducts = data1234
      json.data[0].attributes.QuotationProduct.forEach(({ Price, MOQ, QuotationProductcode }) => {
        const pid = Number(QuotationProductcode);  // Ensure pid is a string
        updatedProducts = updatedProducts.map(item => {
          // Compare as strings
          if (item.id === pid) {
            console.log(`updating ${QuotationProductcode} with ${MOQ} and ${Price}`);

            return {
              ...item,
              attributes: {
                ...item.attributes,
                SellingPrice: Price,
                MOQ: MOQ
              }
            };
          }
          return item;
        });
      });
      setData1234(updatedProducts);
    } catch (error) {
      console.error("Error:", error);
    }
  }
  const fetchData = async () => {
    setIsDataFetched(false)
    const searchParams = new URLSearchParams(window.location.search);
    const selectedItems = searchParams.get('selectedItems') || '';
    const selectedItemsArray = selectedItems.split(',').filter(id => id);
    if (selectedItemsArray.length === 0) {
      setData1234([]); // No selected items, set data1234 to an empty array
      return;
    }
    const productvarid = selectedItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');
    setProgress(30);
    setLoading(true);
    const response = await fetch(
      `${ipp}/api/products?${productvarid}&populate=*&filters[Authorized][$eq]=Authorised&pagination[page]=1`
    );
    setProgress(60);
    const json = await response.json();
    const allSelectedItems = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ipp}/api/products?${productvarid}&populate=*&filters[Authorized][$eq]=Authorised&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allSelectedItems.push(...pageJson.data);
    }
    const responsevar = await fetch(`${ipp}/api/variant-products?${productvarid}&populate=*`);
    const jsonvar = await responsevar.json();
    const newData1234 = [...allSelectedItems, ...jsonvar.data];
    setData1234(newData1234);
    setLoading(false);
    setProgress(100);
    setIsDataFetched(true);

  };

  //  Fetch Data from API End

  const [page, setPage] = useState(1);
  useEffect(() => {
    fetchData123();
  }, [page]);
  const fetchData123 = async () => {
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=id:desc&filters[Authorized][$eq]=Authorised&pagination[page]=${page}${searchQryFilter}`
    );
    const json = await response.json();
    setData123(json.data);
    setMeta123(json.meta);
  };

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    // setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData123(); // Your data fetching function
  }, [debouncedSearchQuery]);

  const handleChangeLimit = () => {
    setPage(1);
  };

  const dataWithSerialNumbers = data1234
    .slice()
    .reverse()
    .sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));
  const handleDeleteRow = id => {
    setData1234(prevData => prevData.filter(item => item.id !== id));
  };

  // Filter the data based on the selected items
  // const [filteredData, setFilteredData] = useState([]);
  // useEffect(() => {
  //   setFilteredData(data123.filter((item) => selectedItemsArray.includes(String(item.id))));
  // }, [data123, selectedItemsArray]);

  // const [selectedItemsToAdd, setSelectedItemsToAdd] = useState([]);

  const GotoProductDesignwithId = useNavigate();
  const uddateProduct = data => {
    if (qut.QuotationName === '') {
    } else {
      const encodedData = encodeURIComponent(JSON.stringify(data));
      GotoProductDesignwithId(`/generate-catalogue1?data=${encodedData}`);
    }
  };

  const GotoProductDesignwithIdc = useNavigate();

  const uddateProductc = data => {
    if (coll.CollectionName === '') {
    } else {
      const encodedData = encodeURIComponent(JSON.stringify(data));
      GotoProductDesignwithIdc(`/generate-collection?data=${encodedData}`);
    }
  };

  const [coll, setColl] = useState({
    CollectionName: '',
    BuyerCompany: '',
    BuyerEmail: '',
    CollectionCode: '',
    BuyerName: '',
    CollectionProduct: [
      {
        ColProduct: '',
        CollectionCode: ''
      }
    ]
  });

  const [qut, setQut] = useState({
    QuotationName: '',
    Q_BuyerCompany: '',
    Q_BuyerEmail: '',
    QuotationCode: '',
    Q_BuyerName: '',
    Q_Status: 'Active',
    QuotationProduct: [
      {
        QuotationProductcode: '',
        QuotationCode: '',
        Price: 0,
        MOQ: 0
      }
    ]
  });
  interface Product {
    QuotationProductcode: string;
    QuotationCode: string;
    Price?: number; // Optional Price property
    MOQ?: number; // Optional MOQ property
  }
  useEffect(() => {
    console.log('qut');
    console.log(qut);

  }, [qut])

  const [updateQuotation, setUpdateQuotation] = useState(searchParams.get('updateQuotation'))
  const [colltectiondata, setCollectiondata] = React.useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    const response = await fetch(`${ipp}/api/collections`);
    const json = await response.json();
    setCollectiondata(json.data);
  };

  const url2 = `${ipp}/api/quotations`;
  const submit = async e => {
    e.preventDefault();
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Quotation Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      const { data: qcode } = await axios.get(`${globalIP}/api/quotations?populate=*`);
      const nextCode = qcode.meta.pagination.total + 1;
      const formData = new FormData();
      // const selectedProducts: Product[] = data1234.map(item => {
      //   const { ProductId, SellingPrice, MOQ } = item.attributes;
      //   const product: Product = {
      //     QuotationProductcode: ProductId,
      //     QuotationCode: nextCatalogueCode,
      //   };

      //   if (SellingPrice && !isNaN(SellingPrice) && MOQ && !isNaN(MOQ)) {
      //     product.Price = SellingPrice;
      //     product.MOQ = MOQ;
      //   }

      //   return product;
      // }).filter(product => product.Price !== undefined && product.MOQ !== undefined);

      const selectedProducts = data1234.map(item => ({
        QuotationProductcode: String(item.id),
        Price: item.attributes.SellingPrice, // Assuming Price is a field in attributes
        MOQ: item.attributes.MOQ, // Assuming MOQ is a field in attributes
        QuotationCode: `QUOT-${nextCode.toString().padStart(3, '0')}`
      }));
      const updatedCatalogue = {
        ...qut,
        QuotationCode: `QUOT-${nextCode.toString().padStart(3, '0')}`,
        QuotationProduct: selectedProducts
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url2, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          handleClose2();
          handleOpen4();
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
    }
  };

  const submit2 = async e => {
    e.preventDefault();
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Quotation Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      const { data: qcode } = await axios.get(`${globalIP}/api/quotations?populate=*`);
      const nextCode = qcode.meta.pagination.total + 1;
      const formData = new FormData();
      const updatedCatalogue = {
        ...qut,
        QuotationCode: `QUOT-${nextCode.toString().padStart(3, '0')}`,
        Q_Status: 'Draft',
        QuotationProduct: data1234.map(item => ({
          QuotationProductcode: String(item.id),
          QuotationCode: `QUOT-${nextCode.toString().padStart(3, '0')}`,
          Price: item.attributes.SellingPrice, // Assuming Price is a field in attributes
          MOQ: item.attributes.MOQ, // Assuming MOQ is a field in attributes
        }))
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url2, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          handleClose2();
          handleOpen4();
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
      // toaster.push(<Message showIcon type='success' >
      //   Saved Successfully
      // </Message>, { placement: 'topCenter' });
    }
  };

  const updateSubmit = () => {
    const nextCatalogueCode = updateQuotation;
    const formData = new FormData();
    const selectedProducts = data1234.map(item => ({
      QuotationProductcode: String(item.id),
      Price: item.attributes.SellingPrice, // Assuming Price is a field in attributes
      MOQ: item.attributes.MOQ, // Assuming MOQ is a field in attributes
      QuotationCode: nextCatalogueCode
    }));
    const updatedCatalogue = {
      ...qut,
      QuotationCode: nextCatalogueCode,
      QuotationProduct: selectedProducts
    };
    formData.append('data', JSON.stringify(updatedCatalogue));
    fetch(`${ipp}/api/quotations/${updateQuotationid}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        handleOpen3();
      })
      .catch(error => console.error(error));
  }
  // const [spt1Name, setSTP1Name] = useState('')
  // const handleInputChange = (inputName, event, index) => {
  //   const value = event.target ? event.target.value : event;
  //   if (inputName == 'Q_BuyerCompany') {
  //     setSelectedCompany(value);
  //   }
  //   if (inputName == 'Q_BuyerName') {
  //     setSelectedBuyer(value);
  //   }

  //   setQut({ ...qut, [inputName]: value });
  // };

  // Update the handleInputChange function
  const handleInputChange = (inputName, event, index) => {
    const value = event.target ? event.target.value : event;

    if (inputName === 'Q_BuyerCompany') {
      setSelectedCompany(value);
      setQut(prevQut => ({
        ...prevQut,
        [inputName]: value
      }));
    } else if (inputName === 'Q_BuyerName') {
      setSelectedBuyer(value);

      // Find the selected buyer and auto-populate email
      const selectedBuyerData = buyeerdata.find(buyer => buyer.value === value);
      if (selectedBuyerData) {
        setQut(prevQut => ({
          ...prevQut,
          [inputName]: value,
          Q_BuyerEmail: selectedBuyerData.email || '' // Auto-populate email
        }));
      } else {
        setQut(prevQut => ({
          ...prevQut,
          [inputName]: value
        }));
      }
    } else {
      setQut(prevQut => ({
        ...prevQut,
        [inputName]: value
      }));
    }
  };
  const handleInputChangec = (inputName, event, index) => {
    const value = event.target ? event.target.value : event;
    setColl({ ...coll, [inputName]: value });
  };

  const Navigate = useNavigate();
  const datattt = () => {
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit(event);
      //   uddateProduct(data1234)
    }
  };
  const datattt2 = () => {
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit2(event);
    }
  };

  const [companydataa, setCompanydataa] = React.useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    fetchData6();
  }, []);

  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.companynm,
        value: item.attributes.companynm
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyeerdata, setBuyeerdata] = React.useState([]);
  const buyeerdata1 = [];
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyernm,
        company: item.attributes.companynm,
        email: item.attributes.email
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const filteredBuyerData = selectedCompany
    ? buyeerdata.filter(item => item.company === selectedCompany)
    : qut?.Q_BuyerCompany
      ? buyeerdata.filter(item => item.company === qut.Q_BuyerCompany)
      : buyeerdata1;

  const [temp, setTemp] = React.useState([]);
  useEffect(() => {
    fetchDatatemp();
  }, []);

  const fetchDatatemp = async () => {
    try {
      const response = await fetch(`${ip}/api/temp-libs`);
      const json = await response.json();
      setTemp(json.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [selectedBuyer, setSelectedBuyer] = useState(null); // Step 1

  // Step 2: Check if there's a matching Temp_Buyer in the temp data
  const findMatchingTempBuyer = () => {
    const tempBuyer = temp.find(item => item.attributes.Temp_Buyer === selectedBuyer);
    return tempBuyer ? tempBuyer.attributes.Temp_Name : null;
  };
  const defaultTempBuyer = temp.find(item => item.attributes.Temp_Buyer === 'Default');
  const defaultTempName = defaultTempBuyer ? defaultTempBuyer.attributes.Temp_Name : null;

  // Step 3: Render the SPT1 div conditionally
  const spt1Name = findMatchingTempBuyer();

  const [showModal, setShowModal] = useState(false);
  const [modalSelectedItems, setModalSelectedItems] = useState([]);

  const handleOpenModal = () => {
    setShowModal(true);
    setModalSelectedItems([...data1234.map(item => item.id)]); // Initialize with currently selected products
  };

  const handleConfirmModal = () => {
    if (modalSelectedItems.length === 0) {
      toaster.push(
        <Message showIcon type="warning">
          Please select at least one product.
        </Message>,
        { placement: 'topEnd' }
      );
    } else {

      const newSelectedItems = modalSelectedItems.map(Number); // Convert to numbers
      const newSelectedItemsString = newSelectedItems.join(',');
      // Update URL params
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('selectedItems', newSelectedItemsString);
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState({}, '', newUrl);
      // Fetch data based on the new selection
      fetchData();
      setShowModal(false);
    }
  };
  const handleModalCheckboxChange = (value, checked) => {
    if (checked) {
      setModalSelectedItems(prevSelected => [...prevSelected, value]);
    } else {
      setModalSelectedItems(prevSelected => prevSelected.filter(item => item !== value));
    }
  };
  const handleSearch = value => {
    setSearchQuery(value);
  };

  const [selectedFormat, setSelectedFormat] = useState('A');
  const handleFormatChange = value => {
    setSelectedFormat(value);
  };
  const [selectedFormat1, setSelectedFormat1] = useState('A');
  const handleFormatChange1 = value => {
    setSelectedFormat1(value);
  };
  const [selectedShare, setSelectedShare] = useState('A');
  const handleFormatChangeShare = value => {
    setSelectedShare(value);
  };

  const handlePanelClick = value => {
    setSelectedFormat1(value);
  };

  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDataco();
  }, []);
  const fetchDataco = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };

  const handleDownloadPPT = () => {
    const ppt = new pptxgen();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 3.2, // Adjust the x-coordinate of the logo
          y: 0.5, // Adjust the y-coordinate of the logo
          w: 4, // Adjust the width of the logo
          h: 1 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343' }
          }
        ],
        { x: 1.4, y: 2, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(email, {
        x: 1.4,
        y: 2.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 1.4,
        y: 3.1,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();

    const addProductSlide = product => {
      const slide = ppt.addSlide();

      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343' }
          }
        ],
        { x: 1.4, y: 0.5, align: 'center' }
      );

      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1, // Adjust the x-coordinate of the logo
          y: 0.4, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: 4, // Adjust the width of the image as needed
        h: 4 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if ('CategoryName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Category Name',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const categoryNameValCell = {
          text: `:  ${product.attributes.CategoryName?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const productidValCell = {
          text: `: ${product.attributes.ProductId?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const pnameValCell = {
          text: `: ${product.attributes.ProductName?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const producttypeValCell = {
          text: `: ${product.attributes.ProductTypeName?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const discValCell = {
          text: `:  ${product.attributes.Description?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      // Add the combined size row if a valid sizeValue is available
      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const sizeValCell = {
          text: `:  ${sizeValue}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const finidhValCell = {
          text: `:  ${product.attributes.FinishName?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const sizeValCell = {
          text: `:  ${price}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#000000' }
        };
        const ntValCell = {
          text: `:  ${product.attributes.NetWeight?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 5,
        y: 1.4,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // Loop through each item in cata and add a slide for each product
    data1234.forEach(item => {
      addProductSlide(item);
    });

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT1 = () => {
    const ppt = new pptxgen();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      const headerBackground = {
        x: 1,
        y: 0.4,
        w: '85%', // Width spans the entire slide
        h: 4, // Height of the header area
        fill: '#423c4e' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#4c3b72' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1.1, // Adjust the x-coordinate of the logo
          y: 3, // Adjust the y-coordinate of the logo
          w: 2, // Adjust the width of the logo
          h: 0.6 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#ffffff' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();

    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const headerBackground1 = {
        x: 0.3,
        y: 0.5,
        w: '10%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground = {
        x: 1.4,
        y: 0.5,
        w: '80%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#4c3b72' // Background color for the header
      };
      slide.addShape('rect', headerBackground);

      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: 4, // Adjust the width of the image as needed
        h: 4 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if ('CategoryName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Category Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: ` ${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: ` ${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const discValCell = {
          text: ` ${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      // Add the combined size row if a valid sizeValue is available
      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: ` ${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#e3dcf3',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: ` ${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            fill: '#d2c8e7',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6,
        y: 1.3,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 16,
              fontFace: 'Arial',
              color: '#000000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 0.7 } // Adjust the position as needed
      );
    };
    let serialCounter = 1;
    // Loop through each item in cata and add a slide for each product
    data1234.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT3 = () => {
    const ppt = new pptxgen();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 3.2, // Adjust the x-coordinate of the logo
          y: 0.5, // Adjust the y-coordinate of the logo
          w: 4, // Adjust the width of the logo
          h: 1 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 2, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(email, {
        x: 1.4,
        y: 2.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 1.4,
        y: 3.1,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = product => {
      const slide = ppt.addSlide();

      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 0.5, align: 'center' }
      );

      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1, // Adjust the x-coordinate of the logo
          y: 0.4, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: 3, // Adjust the width of the image as needed
        h: 3 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      // Add the product attributes as a table

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 1.8; // Adjust the width of each image
        const imageHeight = 1.8; // Adjust the height of each image
        const xOffset = 6; // Adjust the x-offset of the images
        const yOffset = 1.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(2, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      const tableRows = [];

      if ('ProductId' in product.attributes) {
        const productIdAttrCell = {
          text: 'Alias Code',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
        };
        const productIdValCell = {
          text: `: ${product.attributes.ProductId?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        const yOffset = 7; // Adjust the y-coordinate as needed
        const productIdOptions = { ...productIdValCell.options, y: yOffset };
        tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
      }

      // ... (continue adding other attributes to the table)

      const tableOptions = {
        x: 0.5,
        y: 4.8,
        w: '20%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // Loop through each item in cata and add a slide for each product
    data1234.forEach(item => {
      addProductSlide(item);
    });

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 200; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar edit-q-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start" className="edit-head-quot">
              <h3 className="title">Quotations</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/selection`}>Select Product</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Edit Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>

          <Stack spacing={10} className="quotation">
            {/* <button
              onClick={() => console.log(updateQuotation)
              }
            >print data</button> */}
            {/* <button onClick={fetchAndProcessQuotationData}>updateQuotation</button> */}
            <Button appearance="subtle" active onClick={handleOpenModal}>
              Add <span className="add-product"> More</span> Product
            </Button>
            <Button appearance="ghost" color="cyan" onClick={handleOpen}>
              Customize Table
            </Button>

            <Dropdown
              title={(updateQuotation != '' && updateQuotation != null) ? "Update" : "Create"}
              placement="bottomEnd"
              color="cyan"
              appearance="primary"
              disabled={!isDataFetched}
            >
              {updateQuotation != '' && updateQuotation != null &&
                <Dropdown.Item onClick={updateSubmit}>
                  <Stack spacing={80}>
                    <Stack direction="column" alignItems="flex-start">
                      <b>Update Quotation</b>
                      <p>Update Quotation for a buyer</p>
                    </Stack>
                    <Stack>
                      <Icon as={ProjectIcon} />
                    </Stack>
                  </Stack>
                </Dropdown.Item>
              }
              <Dropdown.Item onClick={handleOpen1}>
                <Stack spacing={80}>
                  <Stack direction="column" alignItems="flex-start">
                    <b>Create Quotation</b>
                    <p>Create Quotation for a buyer</p>
                  </Stack>
                  <Stack>
                    <Icon as={ProjectIcon} />
                  </Stack>
                </Stack>
              </Dropdown.Item>
              <Dropdown.Item onClick={handleOpen2}>
                <Stack spacing={130}>
                  <Stack direction="column" alignItems="flex-start">
                    <b>Draft Quotation</b>
                    <p>Draft for a verification</p>
                  </Stack>
                  <Stack>
                    <Icon as={TreemapIcon} />
                  </Stack>
                </Stack>
              </Dropdown.Item>
            </Dropdown>
            {/* <Button color="cyan" appearance="primary">
                Continue
                </Button> */}
          </Stack>
        </Stack>
        <Divider style={{ marginTop: '-20px', marginBottom: '0px' }} />
        <div className="row">
          <Panel>
            <b>{data1234.length} Products</b>

            <Table
              rowHeight={60}
              rowClassName={() => "fixed-row"}
              data={noData ? [] : dataWithSerialNumbers}
              height={tableHeight}
              rowKey="id"
              loading={loading}
              bordered
              cellBordered
              wordWrap="break-word"
              headerHeight={60}

            >
              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key} align="center">
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
          </Panel>
        </div>
        <AddRemoveProductModal {...{
          showModal, setShowModal, fetchData, modalSelectedItems, setModalSelectedItems, label
        }} />
        <ShowDimensionModal {...{ showDimm, handleCloseDimm, selectedRow, finShow, label }} />
        <TableCustomizeDetails
          {...{ open, handleClose, defaultColumns, columnKeys, setColumnKeys }}
        />
        <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the Quotation details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Quotation Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="QuotationName"
                      name="QuotationName"
                      value={qut && qut.QuotationName ? qut.QuotationName : ''}
                      onChange={value => handleInputChange('QuotationName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerCompany"
                      name="Q_BuyerCompany"
                      value={qut && qut.Q_BuyerCompany ? qut.Q_BuyerCompany : ''}
                      onChange={value => handleInputChange('Q_BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerName"
                      name="Q_BuyerName"
                      value={qut && qut.Q_BuyerName ? qut.Q_BuyerName : ''}
                      onChange={value => handleInputChange('Q_BuyerName', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="Q_BuyerEmail"
                      name="Q_BuyerEmail"
                      value={qut && qut.Q_BuyerEmail ? qut.Q_BuyerEmail : ''}
                      onChange={value => handleInputChange('Q_BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={datattt} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal open={open3} onClose={handleClose3} backdrop={'static'} size="xs">
          <Modal.Header>
            <b>Update Quotation.</b>
          </Modal.Header>
          <Modal.Body>
            Quotation successfully updated.
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Link to={`/${ugr}/manageOrdQ`}>
                <Button appearance="primary" color="cyan" active>
                  Ok
                </Button>
              </Link>
              {/* <Button onClick={handleClose3} appearance="primary" color="cyan">
                Ok
              </Button> */}
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open2} onClose={handleClose2} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the draft details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Quotation Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="QuotationName"
                      name="QuotationName"
                      value={qut && qut.QuotationName ? qut.QuotationName : ''}
                      onChange={value => handleInputChange('QuotationName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerCompany"
                      name="Q_BuyerCompany"
                      value={qut && qut.Q_BuyerCompany ? qut.Q_BuyerCompany : ''}
                      onChange={value => handleInputChange('Q_BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>{`${label[0]?.attributes.BuyerName}`}</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerName"
                      name="Q_BuyerName"
                      value={qut && qut.Q_BuyerName ? qut.Q_BuyerName : ''}
                      onChange={value => handleInputChange('Q_BuyerName', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="Q_BuyerEmail"
                      name="Q_BuyerEmail"
                      value={qut && qut.Q_BuyerEmail ? qut.Q_BuyerEmail : ''}
                      onChange={value => handleInputChange('Q_BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={datattt2} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open4} onClose={handleClose4} backdrop="static">
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Stack spacing={15} alignItems="flex-end" justifyContent="flex-end">
              <Link to={`/${ugr}/manageOrdQ`}>
                <Button appearance="subtle" active>
                  Manage Quotation
                </Button>
              </Link>
              <Link to={`/${ugr}/selectionQ`}>
                <Button appearance="primary" color="cyan">
                  Ok
                </Button>
              </Link>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default EditDetailsQ;
